(() => {
  const headers = document.querySelectorAll('.section-header');
  if (!headers.length) return;
  headers.forEach((header) => header.classList.add('sc-header', 'stick-scroll'));
  let previousPosition = window.scrollY;
  let scheduled = false;
  document.body.classList.toggle('new-sticky', previousPosition > 1);
  const updateHeader = () => {
    const position = window.scrollY;
    document.body.classList.toggle('new-sticky', position > 1);
    if (position >= 0) {
      if (position < previousPosition) {
        headers.forEach((header) => header.classList.add('stick-scroll'));
      } else if (position > previousPosition && position >= 500) {
        headers.forEach((header) => header.classList.remove('stick-scroll'));
      }
    }
    previousPosition = position;
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(updateHeader);
    }
  }, { passive: true });
})();
